export default __webpack_public_path__ + "static/salary_payroll-c521b7c4e10634cc79fe4d9be48fa263.png";